var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import getNotifications from "notifications/helpers/getNotifications";
import NotificationFront from "../atoms/NotificationFront";
import { NotificationWrap } from "./subcomponents";
var AccountNotification = function (_a) {
    var accountDetailsObj = _a.accountDetailsObj;
    var acceptedNames = [
        "pastDueNotify",
        "paymentDueTodayNotify",
        "autopayTodayNotify",
        "paymentProcessingNotify",
    ];
    var allNotifications = getNotifications(accountDetailsObj);
    // filter the notifications
    var filteredNotifications = allNotifications.filter(function (notification) {
        return acceptedNames.includes(notification.name);
    });
    // get the first notification type
    if (filteredNotifications.length > 0) {
        // get the first notification type
        var firstNotificationType = filteredNotifications[0].notificationType;
        var soloNotificationArr = [filteredNotifications[0]];
        var isPastDue = filteredNotifications[0].name === "pastDueNotify";
        return (_jsx(NotificationWrap, __assign({ type: firstNotificationType, "data-pastduenotice": isPastDue }, { children: _jsx(NotificationFront, { "data-test": "notification-front", notificationList: soloNotificationArr, handleOnClick: function () { return false; } }) })));
    }
    return null;
};
export default AccountNotification;
//# sourceMappingURL=AccountNotification.js.map